import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { faHomeLgAlt } from '@fortawesome/pro-regular-svg-icons/faHomeLgAlt'
import { faHomeAlt } from '@fortawesome/pro-solid-svg-icons/faHomeAlt'

import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { isRouteAllowed, reverse } from 'src/routes/config'
import withUserData from 'src/HOCs/withUserData'
import withTranslations from 'src/HOCs/withTranslations'
import ExampleMenu from 'src/components/Menu/menus/ExampleMenu'
import AuthMenu from 'src/components/Menu/menus/AuthMenu'
// Style
import menuStyles from './menu.module.scss'

const initialState = {
    exampleMfeIsOpen: false,
    dashboardsIsOpen: false,
    inventoryIsOpen: false,
    supportCenterIsOpen: false,
    servicePortfolioIsOpen: false,
    securityIsOpen: false,
    healthIsOpen: false,
    playbookIsOpen: false,
    itpIsOpen: false,
    kubeportIsOpen: false,
    digitalWorkplaceIsOpen: false,
    contactSearchIsOpen: false,
    documentsIsOpen: false,
    supportWorkspaceIsOpen: false,
}

class MainMenu extends Component {
    static propTypes = {
        /** Defines whether the entire sidebar menu is collapsed or not. */
        parentIsCollapsed: PropTypes.bool,
    }

    state = { ...initialState }

    handleDocumentClick = e => {
        this.setState({
            ...initialState,
        })
    }

    toggleMenuItem = menuItem => e => {
        e?.stopPropagation()
        const key = `${menuItem}IsOpen`
        if (this.props.parentIsCollapsed) {
            this.setState({ ...initialState, [key]: !this.state[key] })
            document.addEventListener('click', this.handleDocumentClick, {
                once: true,
            })
        } else {
            this.setState({ [key]: !this.state[key] })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.parentIsCollapsed !== this.props.parentIsCollapsed) {
            this.setState({ ...initialState })
            if (prevProps.parentIsCollapsed) {
                document.removeEventListener('click', this.handleDocumentClick)
            }
        }
    }

    renderExampleMfeMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { exampleMfeIsOpen } = this.state

        if (!isRouteAllowed(userData, 'example-mfe')) {
            return null
        }

        return (
            <ExampleMenu
                isOpen={exampleMfeIsOpen}
                onClick={this.toggleMenuItem('exampleMfe')}
                parentIsCollapsed={parentIsCollapsed}
            />
        )
    }

    renderAuthMenu() {
        const { userData, parentIsCollapsed } = this.props
        if (isRouteAllowed(userData, 'auth-mfe')) {
            return <AuthMenu parentIsCollapsed={parentIsCollapsed} />
        }
        return null
    }

    render() {
        const { t, parentIsCollapsed } = this.props

        return (
            <>
                <nav className={menuStyles.main}>
                    <MainMenuItem
                        icon={faHomeLgAlt}
                        iconActive={faHomeAlt}
                        title={t('Home')}
                        to={reverse('home')}
                        parentIsCollapsed={parentIsCollapsed}
                        exact={true}
                    />
                    {this.renderExampleMfeMenu()}
                    {this.renderAuthMenu()}
                </nav>
            </>
        )
    }
}

export default withTranslations('MainMenu', 'MainMenu')(withUserData(MainMenu))
